// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3le-g","select":"Header_select__ucv3l","clinic":"Header_clinic__2OVnW"};